import React from 'react'
import { withRouter } from 'react-router'
import { Helmet } from 'react-helmet'
import HomeHeader from '../components/HomePageHeader'
import Footer from '../components/Footer'
import SalesForm from './components/SalesForm'

import styles from './Sales.module.css'
import { LogoShowcase } from '../Landing/Home/Home'

const Sales = () => {
  return (
    <div className="body-bg full-height">
      <Helmet>
        <title>Speak to Sales - Tiiny Host</title>
        <meta property="og:title" content="Speak to Sales - Tiiny Host" />
        <meta
          property="og:description"
          content="Get in touch with our sales team to discuss your business needs and find the perfect hosting solution."
        />
        <meta
          name="description"
          content="Get in touch with our sales team to discuss your business needs and find the perfect hosting solution."
        />
      </Helmet>

      <HomeHeader />

      <div className="container-lg">
        <div className={styles.salesContainer}>
          <div className={styles.headerSection}>
            <h1 className={styles.title}>Speak to Sales</h1>
            <p className={styles.subtitle}>Talk to us to see how Tiiny can work transform your business</p>
          </div>

          <div className={styles.contentSection}>
            <div className={styles.infoSection}>
              <div className={styles.infoCard}>
                <h3 className={styles.infoTitle}>Empower your team with Tiiny</h3>
                <ul className={styles.benefitsList}>
                  <li>
                    <img src="/assets/icons/tick.svg" alt="check" height="20px" width="20px" className="me-2" /> Shared
                    team workspaces
                  </li>
                  <li>
                    <img src="/assets/icons/tick.svg" alt="check" height="20px" width="20px" className="me-2" /> Custom
                    quotas
                  </li>
                  <li>
                    <img src="/assets/icons/tick.svg" alt="check" height="20px" width="20px" className="me-2" />{' '}
                    Collaborative editing and feedback
                  </li>
                  <li>
                    <img src="/assets/icons/tick.svg" alt="check" height="20px" width="20px" className="me-2" /> API
                    access for seamless integration
                  </li>
                  <li>
                    <img src="/assets/icons/tick.svg" alt="check" height="20px" width="20px" className="me-2" />{' '}
                    Dedicated account management
                  </li>
                  <li>
                    <img src="/assets/icons/tick.svg" alt="check" height="20px" width="20px" className="me-2" />{' '}
                    Priority support and onboarding
                  </li>
                </ul>
              </div>

              <div>
                <LogoShowcase className="mt-2 mb-2" />
              </div>

              <div className={styles.infoCard}>
                <h3 className={styles.infoTitle}>What to Expect</h3>
                <div className={styles.expectationsList}>
                  <div className={styles.expectationItem}>
                    <strong>Quick Response</strong>
                    <br />
                    We'll get back to you within 24 hours
                  </div>
                  <div className={styles.expectationItem}>
                    <strong>Personalized Demo</strong>
                    <br />
                    See how Tiiny Host can work for your specific use case
                  </div>
                  <div className={styles.expectationItem}>
                    <strong>Custom Pricing</strong>
                    <br />
                    Get a quote tailored to your business needs
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.formSection}>
              <SalesForm />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default withRouter(Sales)
